exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-block[data-v-4b751897] {\n  position: relative;\n}\n.card-block p[data-v-4b751897] {\n    margin-bottom: 0;\n    min-height: 24px;\n}\n.card-title[data-v-4b751897] {\n  padding-right: 70px;\n}\n.cancelationDays[data-v-4b751897] {\n  font-size: 14px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4b751897","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Activity/ActivityDescription.vue
// module id = 643
// module chunks = 3